module.exports = __webpack_public_path__ + "static/media/implementation-guides-image.a8b0368c.jpg";